<template>
  <div id="app">
    <template v-if="isFinishedAnimation">
      <transition name="fade" mode="out-in">
        <router-view v-slot="{ Component }">
          <template v-if="isFinishedAnimation">
            <component :is="Component" />
          </template>
        </router-view>
      </transition>
    </template>
    <transition name="fade-quick" @after-leave="isFinishedAnimation = true">
      <div v-if="!isAppReady" class="loading-global">
        <div class="logo-container">
          <img class="top-logo" src="@/assets/img/teaser-main-logo.svg" />
          <a href="https://www.soco.id">
            <img class="soco-logo" src="@/assets/img/header-logo-soco.svg" />
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Axios from "axios";
const Config = require("../config/default.env").default;

export default {
  data() {
    return {
      isAppReady: false,
      isFinishedAnimation: false,
    };
  },
  methods: {
    async getReportCount() {
      this.$store.dispatch("$_InsightFactory/fetchReportCount").then(() => {
        this.isAppReady = true;
        if (this.$store.state.$_InsightFactory.reportCount === 0) {
          this.$router.replace("/").catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
        }
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener("onWindowResize", this.onWindowResize);
  },
  mounted() {
    window.addEventListener("onWindowResize", this.onWindowResize);
    if (document.cookie.indexOf("sso_token") < 0) {
      Axios.get(Config.MS_SSO_BROKER_API_URL)
        .then((res) => {
          try {
            if (res.request.responseURL) {
              const url = new URLSearchParams(res.request.responseURL);
              document.cookie =
                "sso_token=" +
                url.get("token") +
                "; domain=.insightfactory.soco.id;";
            }
            this.getReportCount();
          } catch (err) {
            this.isAppReady = true;
            // this.$toasted.global.error(err);
          }
        })
        .catch((err) => {
          console.log(err);
          this.isAppReady = true;
          // this.$toasted.global.error(err);
        });
    } else {
      this.getReportCount();
    }
  },
};
</script>
<style lang="scss">
.logo-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.loading-global {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#app {
  font-family: $lato;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  background: $insightFactoryRed;
}
html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: $insightFactoryRed;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-quick-enter-active,
.fade-quick-leave-active {
  transition: opacity 1s;
}

.fade-quick-enter,
.fade-quick-leave-to {
  opacity: 0;
}
</style>
